<template>
  <div>
    <NavBar></NavBar>
    <div class="container">
      <h2>Nutzer</h2>
      <table class="table">
        <thead>
        <tr>
          <th>#</th>
          <th>Name</th>
          <th>Login</th>
          <th>Admin?</th>
          <th>Community</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="user in users" :key="user.id">
          <td>{{ user.id }}</td>
          <td>{{ user.firstName }} {{ user.lastName }}</td>
          <td>{{ user.login }}</td>
          <td>
            <span v-if="user.roles.includes('ROLE_ADMIN')"
                  title="Rolle Admin"
                  class="badge">Admin</span>
            <span v-else
                  @click="showAdminDialog(user)"
                  title="Nutzer zum Administrator machen."
                  class="badge inactive action">Admin</span>
          </td>
          <td>{{ usersLocationName(user) }}</td>
        </tr>
        </tbody>
      </table>
    </div>
    <Dialog :visible="adminDialogVisible"
            title="Admin-Rechte"
            ok-button-text="Ja"
            @cancel="adminDialogVisible = false"
            @ok="makeUserAdmin"
            message="Wollen Sie dem Nutzer wirklich Admin-Rechte vergeben?">

    </Dialog>
  </div>
</template>

<script>
import NavBar from "@/components/partial/NavBar.vue";
import {broadcast} from "@/util/eventHandler.js";
import {communicator} from "@/util/communicator.js";
import Dialog from "@/components/partial/Dialog.vue";

export default {
  name: "User",
  components: {NavBar, Dialog},
  created() {
    this.fetchUsers();
    this.fetchCommunities();
  },
  mounted() {
    window.addEventListener("scroll", this.onScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.onScroll);
  },
  data() {
    return {
      loading: false,
      pageIndex: 0,
      users: [],
      totalUserCount: undefined,
      communities: {},
      adminDialogVisible: false,
      selectedUser: undefined
    };
  },
  methods: {
    showAdminDialog(user) {
      this.adminDialogVisible = true;
      this.selectedUser = user;
    },
    async makeUserAdmin() {
      try {
        await communicator.post(`/users/${this.selectedUser.id}/set-roles`, {
          roles: [
            "ROLE_ADMIN"
          ]
        });
        for(const user of this.users) {
          if(user.id !== this.selectedUser.id) continue;
          user.roles.push("ROLE_ADMIN");
        }
      } catch (e) {
        broadcast("error", e.response.data);
      }
      this.adminDialogVisible = false;
      this.selectedUser = undefined;
    },
    usersLocationName(user) {
      if (user.communityId === null) return "";
      if (!this.communities[user.communityId]) return "";
      return this.communities[user.communityId].name;
    },
    onScroll() {
      if (this.loading) return;
      if (this.totalUserCount && this.totalUserCount <= this.users.length) return;
      const atBottom = Math.ceil(window.scrollY) + window.innerHeight >= document.body.offsetHeight;
      if (atBottom) {
        this.pageIndex++;
        this.fetchUsers();
      }
    },

    async fetchCommunities() {
      try {
        const response = await communicator.get("/communities");
        response.data.items.forEach(community => {
          this.communities[community.id] = community;
        });
      } catch (e) {
        broadcast("error", e.response.data);
      }
    },

    async fetchUsers() {
      if (this.loading) return;
      this.loading = true;
      try {
        const response = await communicator.get(`/admin/users?pageIndex=${this.pageIndex}&pageSize=100`);
        response.data.users
            .filter(user => user.roles.includes("ROLE_MODERATOR"))
            .forEach(user => this.users.push(user));
        this.totalUserCount = response.data.paging.totalItemCount;
      } catch (e) {
        broadcast("error", e.response.data);
      }
      this.loading = false;
    }
  }
};
</script>

<style scoped>
.badge.inactive {
  opacity: 0.3;
}

.badge.inactive.action:hover {
  cursor: pointer;
  opacity: 0.6;
}
</style>
